import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Search, Heart, BookOpen, Wind, Baby } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: <Search className="w-6 h-6 text-terracotta" data-id="element-57" />,
    title: 'Descubre qué estás repitiendo (aunque no lo veas)',
    description: 'Aprende a mapear tu árbol genealógico emocional y descubre exactamente de quién heredaste tus bloqueos actuales.'
  }, {
    icon: <Wind className="w-6 h-6 text-terracotta" data-id="element-58" />,
    title: 'Suelta lo que nunca fue tuyo',
    description: 'Ejercicios prácticos y meditaciones guiadas para devolver la carga emocional a quien le pertenece, desde el amor.'
  }, {
    icon: <BookOpen className="w-6 h-6 text-terracotta" data-id="element-59" />,
    title: 'Ejercicios que te hacen entender y liberar en el momento',
    description: 'Plantillas de escritura profunda diseñadas para acceder a tu mente subconsciente y reprogramar creencias limitantes.'
  }, {
    icon: <Baby className="w-6 h-6 text-terracotta" data-id="element-60" />,
    title: 'Reconecta con la parte de ti que necesita sanar',
    description: 'Conecta con tu versión más vulnerable para sanar las heridas de la infancia que se entrelazan con tu herencia.'
  }, {
    icon: <Heart className="w-6 h-6 text-terracotta" data-id="element-61" />,
    title: 'Deja de vivir desde el dolor de tu historia',
    description: 'Aprende a honrar a tus ancestros a través de tu éxito, tu felicidad y tu abundancia, en lugar de a través del sufrimiento.'
  }];
  return <section className="py-24 bg-beige-light relative" data-id="element-62">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-63">
        <FadeIn className="text-center mb-16" data-id="element-64">
          <h2 className="font-heading text-4xl text-charcoal mb-4" data-id="element-65">
            ¿Qué encontrarás dentro?
          </h2>
          <div className="w-16 h-[1px] bg-gold mx-auto" data-id="element-66" />
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-67">
          {features.map((feature, index) => <FadeIn key={index} delay={index * 0.1} className={`bg-white p-8 rounded-sm shadow-sm border border-beige-dark ${index === 4 ? 'md:col-span-2 lg:col-span-1' : ''}`} data-id="element-68">
              <div className="w-12 h-12 bg-terracotta/10 rounded-full flex items-center justify-center mb-6" data-id="element-69">
                {feature.icon}
              </div>
              <h3 className="font-heading text-xl text-charcoal mb-3" data-id="element-70">
                {feature.title}
              </h3>
              <p className="font-body text-charcoal/70 leading-relaxed text-sm" data-id="element-71">
                {feature.description}
              </p>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}